import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { isAdminUser } from 'utils/userUtils';
import AppContainer from 'view/containers/AppContainer';
// import Admin from 'pages/dashboard/Admin';
import AdminFilePage from 'pages/dashboard/AdminFilePage';
// import RecordSearchPage from 'pages/RecordSearchPage';
import BackendSearchPage from 'pages/backendSearch/BackendSearchPage';
// import Dashboard from 'pages/dashboard/Dashboard';
import CartPage from 'pages/cart/CartPage';
import CheckoutPage from 'pages/cart/CheckoutPage';
// import ConfirmationPage from 'pages/cart/ConfirmationPage';
import AccountSettings from 'pages/AccountSettings';
import AirtableInstructionsPage from 'pages/Airtable';
// import PropertySearch from 'pages/PropertySearch';
import PropertyNotFound from 'pages/PropertyNotFound';
import AcceptableUsePolicy from 'pages/AcceptableUsePolicy';
import SmsTerms from 'pages/SmsTerms';
import FaqPage from 'pages/faq/FaqPage';
import Disclaimer from 'pages/Disclaimer';
import MyDocuments from 'pages/MyDocuments';
import SignIn from 'pages/auth/SignIn';
import SignUp from 'pages/auth/SignUp';
import ForgotPassword from 'pages/auth/ForgotPassword';
import ResetPassword from 'pages/auth/ResetPassword';
import AcceptInvitation from 'pages/auth/AcceptInvitation';
import MobileSearchPage from 'pages/mobile/MobileSearchPage';
import PaymentSuccess from 'pages/PaymentSuccess';
import Unsubscribe from 'pages/Unsubscribe';

import DashboardOverview from 'pages/_rd_dashboard/DashboardOverview';
import Portfolio from 'pages/_rd_dashboard/Portfolio';
import PortfolioMap from 'pages/_rd_dashboard/PortfolioMap';
import Alerts from 'pages/_rd_dashboard/Alerts';
import Compliance from 'pages/_rd_dashboard/Compliance';
import Settings from 'pages/_rd_dashboard/Settings';
import EmailSettings from 'pages/_rd_dashboard/EmailSettings';

import AdminTopVios from 'pages/_rd_dashboard/AdminTopVios';
import AdminFiles from 'pages/_rd_dashboard/AdminFiles';
import AdminPortfolios from 'pages/_rd_dashboard/AdminPortfolios';
import AdminNotifications from 'pages/_rd_dashboard/AdminNotifications';
import AdminUsers from 'pages/_rd_dashboard/AdminUsers';
import AdminSubscriptionsPage from 'pages/_rd_dashboard/AdminSubscriptionsPage';
import { PortfolioPage } from 'view/pages/Portfolio';
import { PortfolioDetailPage } from 'view/pages/PortfolioDetailPage';
import { PortfolioPropertyPage } from 'view/pages/PortfolioPropertyPage';
import QueueMonitor from 'pages/_rd_dashboard/QueueMonitor';
import DatasetMonitor from 'pages/_rd_dashboard/DatasetMonitor';
import ResolveViolationsPage from 'view/pages/ResolveViolations';
import RepresentOathHearingsPage from 'view/pages/RepresentOathHearings';
import AdminEmailTracking from 'pages/_rd_dashboard/AdminEmailTracking';
import AdminSmsResponses from 'pages/_rd_dashboard/AdminSmsResponses';
import AdminStreetViewReports from 'pages/_rd_dashboard/AdminStreetViewReports';
import ResolutionSuccessPage from '../view/pages/ResolveViolation';
import SocialCallback from 'view/pages/auth/SocialCallback';
import PopupCallback from 'view/pages/auth/PopupCallback';
import {
	EmailPreferences,
	UnsubscribeFeedback,
	ManageNotifications,
} from 'pages/emailPreferences';
import OrganizationsPage from 'pages/Organizations/OrganizationsPage';
import OrganizationMembersPage from 'pages/Organizations/OrganizationMembersPage';

// import { useMediaPredicate } from 'react-media-hook';
// import { MOBILE_SIZE } from 'utils/mediaQueryUtils';

// function LandingPage() {
// 	const isMobile = useMediaPredicate(MOBILE_SIZE);
// 	if (isMobile) {
// 		return <MobileSearchPage />;
// 	}
// 	return <PropertySearch />;
// }

const routes = {
	'/property-not-found': PropertyNotFound,
	'/sign-in': SignIn,
	'/auth/callback': SocialCallback,
	'/auth/popup-callback': PopupCallback,
	'/sign-up': SignUp,
	'/forgot-password': ForgotPassword,
	'/recover-user/:resetToken': ResetPassword,
	'/accept-invitation/:token': AcceptInvitation,
	'/email-preferences/:token': EmailPreferences,
	'/unsubscribe-feedback/:token': UnsubscribeFeedback,
	'/manage-notifications/:token': ManageNotifications,
	'/use-policy': AcceptableUsePolicy,
	'/sms-terms': SmsTerms,
	'/faq': FaqPage,
	'/disclaimer': Disclaimer,
	'/my-documents': MyDocuments,
	'/dashboard/overview': DashboardOverview,
	'/dashboard/portfolio/:portfolioId/property/:propertyId':
		PortfolioPropertyPage,
	'/dashboard/portfolio/:portfolioId': PortfolioDetailPage,
	'/dashboard/portfolio/:portfolioId/overview': PortfolioDetailPage,
	'/dashboard/portfolio-old': Portfolio,
	'/dashboard/portfolio': PortfolioPage,
	'/dashboard/alerts': Alerts,
	'/dashboard/map': PortfolioMap,
	'/dashboard/compliance': Compliance,
	'/dashboard/settings': Settings,
	'/dashboard/organization/:id/members': OrganizationMembersPage,
	'/dashboard/organizations': OrganizationsPage,
	'/email-settings': EmailSettings,
	'/dashboard': Portfolio,
	'/admin/top-violations': AdminTopVios,
	'/admin/users': AdminUsers,
	'/admin/portfolios': AdminPortfolios,
	'/admin/subscriptions': AdminSubscriptionsPage,
	'/admin/notifications': AdminNotifications,
	'/admin/email-tracking': AdminEmailTracking,
	'/admin/sms-responses': AdminSmsResponses,
	'/admin/street-view-reports': AdminStreetViewReports,
	'/admin/files': AdminFiles,
	'/admin/queue-monitor': QueueMonitor,
	'/admin/dataset-monitor': DatasetMonitor,
	'/admin': AdminPortfolios,
	'/file-admin': AdminFilePage,
	'/account-settings': AccountSettings,
	'/backend-search': BackendSearchPage,
	'/search': MobileSearchPage,
	'/airtable-instructions': AirtableInstructionsPage,
	'/cart': CartPage,
	'/checkout': CheckoutPage,
	'/payment-success': PaymentSuccess,
	'/manageNotifications': Unsubscribe,
	'/resolve-violations': ResolveViolationsPage,
	'/resolve-violation/success': ResolutionSuccessPage,
	'/represent-oath-hearings': RepresentOathHearingsPage,
	// '/order-confirmation': ConfirmationPage,
};

// Every /admin URL is staff-only. AdminLayout previously only checked
// isLoggedIn, so a non-admin could still land on these pages via a
// direct URL hit. RequireAdmin blocks that before the page mounts.
// A generic prefix check rather than a per-path allowlist, so every new
// /admin/* route (e.g. dataset-monitor, whose API is itself admin-gated)
// is covered automatically - exported so that guarantee is unit-testable.
export const isAdminOnlyPath = (path) =>
	path === '/admin' || path.startsWith('/admin/');

/**
 * RequireAdmin
 * Renders children only for admin users (user_group ADMIN via isAdminUser).
 * - While the user store is still resolving (isLoading/isUpdating) it renders
 *   null: no redirect (avoids bouncing admins on hard refresh) and no children
 *   (avoids pre-auth API calls from the gated page).
 * - Resolved and logged out -> redirect to /sign-in (mirrors AdminLayout).
 * - Resolved, logged in, not admin -> redirect to /dashboard/overview (the
 *   standard logged-in landing route; the app has no dedicated not-authorized view).
 */
export function RequireAdmin({ children }) {
	const isLoggedIn = useSelector((state) => !!state.user.userData?.id);
	const isLoading = useSelector((state) => state.user.isLoading);
	const isUpdating = useSelector((state) => state.user.isUpdating);
	const userData = useSelector((state) => state.user.userData);

	if (isAdminUser(userData)) {
		return children;
	}

	if (isLoading || isUpdating) {
		return null;
	}

	if (!isLoggedIn) {
		return <Redirect to="/sign-in" />;
	}

	return <Redirect to="/dashboard/overview" />;
}

function NonPropertyRoutes() {
	return Object.keys(routes).map((path) => {
		const Component = routes[path];

		// let hideHeaderSearch = false;
		// if (path === '/') {
		// 	hideHeaderSearch = true;
		// }

		const isAdminOnly = isAdminOnlyPath(path);

		return (
			<Route key={path} path={path}>
				<AppContainer showSidebar={false}>
					{isAdminOnly ? (
						<RequireAdmin>
							<Component />
						</RequireAdmin>
					) : (
						<Component />
					)}
				</AppContainer>
			</Route>
		);
	});
}

export default NonPropertyRoutes;
